<ng-container *transloco="let t; prefix: scope">
  <p-dialog
    [header]="t('fetchCloudDatabaseKey')"
    [(visible)]="visible"
    showEffect="fade"
    [style]="{ width: '900px' }"
    (onHide)="closeDialog()"
    [draggable]="false">
    <p>{{ t('infoMessage1') }}</p>
    <p class="mb-6">{{ t('infoMessage2') }}</p>

    <ng-container *ngIf="cloudCompanies$ | async as ccc">
      <p-table [columns]="cloudCompanyColumns$ | async" [value]="ccc.data" [tableStyle]="{ 'table-layout': 'fixed' }">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              <div
                class="my-3 whitespace-normal"
                *ngIf="!ccc.loading; else loadingCloudCompany"
                [innerHTML]="t('notFoundMessage') | safeHtml"></div>
              <ng-template #loadingCloudCompany>{{ t('loadingDataPleaseWait') }}</ng-template>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="font-normal text-center" *ngFor="let col of columns" [style.width]="col.width || 'auto'">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td>{{ rowData.orgNumber }}</td>
            <td>{{ rowData.name }}</td>
            <td>{{ rowData.publicKey }}</td>
            <td class="text-center">
              <bl-frontend-button (onclick)="connectCloudCompany(rowData)" [text]="t('add')"></bl-frontend-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    <p-footer class="mt-6">
      <bl-frontend-button  (onclick)="closeDialog()" [text]="'shared.close' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog>
</ng-container>
